import React from 'react';
import { Modal, Button, Form, Input, Space, message } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import AxiosOICStat from '../../AxiosOICStat';

const CountryCreateModal = ({ visible, onCancel, onCreate }) => {
    const [form] = Form.useForm();

    const handleCreateSubmit = (values) => {
        const altNamesArray = values.alt_names_list 
            ? values.alt_names_list.map(item => item.name).filter(name => name && name.length > 0)
            : [];
        
        const submitData = {
            c_short_name_eng: values.c_short_name_eng,
            c_full_name_eng: values.c_full_name_eng,
            c_short_name_fr: values.c_short_name_fr || null,
            c_short_name_arb: values.c_short_name_arb || null,
            c_full_name_fr: values.c_full_name_fr || null,
            c_full_name_arb: values.c_full_name_arb || null,
            c_phone_prefix: values.c_phone_prefix || null,
            c_alt_names: altNamesArray.length > 0 ? altNamesArray : null,
            c_type: values.c_type || null,
            c_traffic_code: values.c_traffic_code || "N/A",
            c_short_name_tr: values.c_short_name_tr || "N/A",
            c_full_name_tr: values.c_full_name_tr || "N/A",
        };

        AxiosOICStat.post('countries/create-country', submitData)
            .then((response) => {
                message.success('Country created successfully');
                onCreate(response.data);
                form.resetFields();
                onCancel();
            })
            .catch(err => {
                console.error('Error creating country:', err);
                const errorMessage = err.response?.data?.detail || 'Error creating country';
                message.error(errorMessage);
            });
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            visible={visible}
            title="Create Country"
            onCancel={handleCancel}
            width="50%"
            footer={[
                <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                <Button key="create" type="primary" onClick={() => form.submit()}>Create</Button>,
            ]}
        >
            <Form form={form} onFinish={handleCreateSubmit} layout="vertical">
                <Form.Item 
                    label="Short Name (English)" 
                    name="c_short_name_eng"
                    rules={[{ required: true, message: 'Please input country short name in English!' }]}
                >
                    <Input placeholder="Enter country short name (English)" />
                </Form.Item>
                
                <Form.Item 
                    label="Full Name (English)" 
                    name="c_full_name_eng"
                    rules={[{ required: true, message: 'Please input country full name in English!' }]}
                >
                    <Input placeholder="Enter full country name (English)" />
                </Form.Item>

                <Form.Item label="Short Name (French)" name="c_short_name_fr">
                    <Input placeholder="Enter country short name (French)" />
                </Form.Item>

                <Form.Item label="Full Name (French)" name="c_full_name_fr">
                    <Input placeholder="Enter full country name (French)" />
                </Form.Item>

                <Form.Item label="Short Name (Arabic)" name="c_short_name_arb">
                    <Input placeholder="Enter country short name (Arabic)" />
                </Form.Item>

                <Form.Item label="Full Name (Arabic)" name="c_full_name_arb">
                    <Input placeholder="Enter full country name (Arabic)" />
                </Form.Item>

                <Form.Item label="Short Name (Turkish)" name="c_short_name_tr">
                    <Input placeholder="Enter country short name (Turkish) - defaults to N/A" />
                </Form.Item>

                <Form.Item label="Full Name (Turkish)" name="c_full_name_tr">
                    <Input placeholder="Enter full country name (Turkish) - defaults to N/A" />
                </Form.Item>
                
                <Form.Item label="Alternative Names">
                    <Form.List name="alt_names_list">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'name']}
                                            rules={[{ required: false }]}
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Input placeholder="Enter alternative name" />
                                        </Form.Item>
                                        <MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red', cursor: 'pointer' }} />
                                    </Space>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                        Add Alternative Name
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item label="Phone Prefix" name="c_phone_prefix">
                    <Input placeholder="Enter phone prefix (e.g., +90)" />
                </Form.Item>

                <Form.Item label="Country Type" name="c_type">
                    <Input placeholder="Enter country type (optional)" />
                </Form.Item>
                
                <Form.Item label="Traffic Code" name="c_traffic_code">
                    <Input placeholder="Enter traffic code - defaults to N/A" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CountryCreateModal;
